<template>
    <b-form-group>
        <label class="mb-1 text-lg d-flex align-items-center">
            Mật khẩu
        </label>
        <div class="relative">
            <b-input v-model="entry.password" :type="showPassword ? 'text' : 'password'" placeholder="Nhập mật khẩu..." />
            <i @click="showPassword = !showPassword" class='z-10 absolute top-1/2 -translate-y-1/2 right-3 bx bx-sm bx-low-vision'></i>
        </div>
    </b-form-group>
</template>

<script>
export default {
    props: {
        value: Object,
    },
    data: () => ({
        entry: {
            password: "",
        },
        showPassword: false,
    }),
    watch: {
        "entry.password": {
            handler: function () {
                this.$emit("update", {
                    ...this.value,
                    password: this.entry.password,
                });
            },
            deep: true,
        },
        "value.password": {
            handler: function () {
                this.entry.password = this.value.password;
            },
            deep: true,
        },
    },
    created() {
        this.entry = this.value;
    },
};
</script>